export const TICKET_STATUS = {
  NEW: 'new',
  PENDING: 'pending',
  SOLVED: 'solved',
  OPEN: 'open',
  CLOSED: 'closed',
  HOLD: 'hold',
};

export const TICKET_PRIORITY = {
  LOW: 'low',
  NONE: 'none',
  URGENT: 'urgent',
  MEDIUM: 'medium',
  HIGH: 'high',
};

export const UPDATE_DATA_TYPES = {
  ASSIGNERS: 'assigners',
  COMPANIES: 'companies',
  REQUESTER: 'requester',
  STATUS: 'status',
  PRIORITY: 'priority',
  SUBJECT: 'subject',
  DESCRIPTION: 'description',
  TYPE: 'type',
};

export const COMMENT_TYPES = {
  reply: 'Reply',
  note: 'Note',
};

export const TICKET_STATUS_FILTER_OPTIONS = [
  {
    value: TICKET_STATUS.NEW,
    displayName: 'New',
  },
  {
    value: TICKET_STATUS.PENDING,
    displayName: 'Pending',
  },
  {
    value: TICKET_STATUS.SOLVED,
    displayName: 'Solved',
  },
  {
    value: TICKET_STATUS.OPEN,
    displayName: 'Open',
  },
  {
    value: TICKET_STATUS.CLOSED,
    displayName: 'Closed',
  },
  {
    value: TICKET_STATUS.HOLD,
    displayName: 'Hold',
  },
];

export const TICKET_CHANNEL_FILTER_OPTIONS = [
  {
    value: 'web',
    displayName: 'Web',
  },
  {
    value: 'email',
    displayName: 'Email',
  },
  {
    value: 'api',
    displayName: 'API',
  },
];

export const TICKET_PRIORITY_FILTER_OPTIONS = [
  {
    value: null,
    displayName: 'None',
    flagState: 'none',
  },
  {
    value: TICKET_PRIORITY.LOW,
    displayName: 'Low',
    flagState: 'low',
  },
  {
    value: TICKET_PRIORITY.MEDIUM,
    displayName: 'Medium',
    flagState: 'normal',
  },
  {
    value: TICKET_PRIORITY.HIGH,
    displayName: 'High',
    flagState: 'high',
  },
  {
    value: TICKET_PRIORITY.URGENT,
    displayName: 'Urgent',
    flagState: 'urgent',
  },
];

export const TICKET_SUMMARY_DAYS_PERIOD = 30;

export const TICKET_STATUS_MAPPING = {
  new: { color: 'yellow', status: 'New' },
  open: { color: 'blue', status: 'Open' },
  pending: { color: 'purple', status: 'Pending' },
  solved: { color: 'green', status: 'Solved' },
  closed: { color: 'grey', status: 'Closed' },
  hold: { color: 'red', status: 'Hold' },
};

export const TICKET_ORIGINS = {
  zendesk: {
    value: 'zendesk',
    displayName: 'Zendesk',
  },
  freshdesk: {
    value: 'freshdesk',
    displayName: 'Freshdesk',
  },
  intercom: {
    value: 'intercom',
    displayName: 'Intercom',
  },
  jira: {
    value: 'jira',
    displayName: 'Jira',
  },
  hubspot: {
    value: 'hubspot',
    displayName: 'Hubspot',
  },
};

export const TICKET_CHANNELS = {
  web: 'web',
  api: 'api',
  email: 'email',
  chat: 'chat',
  phone: 'phone',
  portal: 'portal',
};

export const TICKET_PRIORITY_VALUE_DISPLAY_MAPPING = {
  null: 'None',
  [TICKET_PRIORITY.LOW]: 'Low',
  [TICKET_PRIORITY.MEDIUM]: 'Medium',
  [TICKET_PRIORITY.HIGH]: 'High',
  [TICKET_PRIORITY.URGENT]: 'Urgent',
};

export const TICKET_CHANNEL_MAPPING = {
  200: 'email',
  210: 'phone',
  220: 'chat',
  230: 'portal',
  240: 'api',
  250: 'web',
};

export const TICKET_CHANNEL_VALUES = {
  200: 'Email',
  210: 'Phone',
  220: 'Chat',
  230: 'Portal',
  240: 'Api',
  250: 'Web',
};

export const TICKET_ENTITY_MAPPING = {
  400: 'Account',
  410: 'Organization',
};

export const TICKET_ENTITY_VALUE_MAPPING = {
  account: 400,
  organization: 410,
};

export const TICKET_ORIGIN_MAPPING = {
  300: 'zendesk',
  310: 'intercom',
  320: 'freshdesk',
  330: 'jira',
  340: 'hubspot',
};

export const TICKET_ORIGIN_VALUES = {
  300: 'Zendesk',
  310: 'Intercom',
  320: 'Freshdesk',
  330: 'Jira',
  340: 'Hubspot',
};

export const TICKET_PRIORITY_VALUES = {
  100: 'low',
  110: 'medium',
  120: 'high',
  130: 'urgent',
};

export const TICKET_PRIORITY_STATUS_VALUES = {
  10: 'new',
  20: 'open',
  30: 'pending',
  40: 'hold',
  50: 'closed',
  60: 'solved',
};

export const REQUESTER_VALUE_MAPPING = {
  500: 'contact',
  501: 'admin',
};

export const ASSIGNEES_VALUE_MAPPING = {
  510: 'admin',
  520: 'visitor',
  530: 'bot',
  531: 'contact',
};

export const TICKET_ACTIVITY_TYPE = {
  UPDATE: 'update',
  REPLAY: 'comment',
};

export const TICKET_ACTIVITY_SORTING_TYPE = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
};

export const TICKET_DEFAULT_PAGE_SIZE = 20;
export const TICKET_DEFAULT_PAGE = 1;

export const TICKET_USER_TYPES = {
  ADMIN: 'admin',
  CONTACT: 'contact',
  BOT: 'bot',
  TEAM: 'team',
  VISITOR: 'visitor',
};
